import React from "react";
import PropTypes from "prop-types";
import { H1 } from "components/core/Typography";
import { ShowNumber } from "components/brand/ClickToCall";
import { StarReviewV2 } from "components/review/StarReviewV2";
import "./FacilityPageHeader.scss";

const FacilityPageHeader = ({
	name,
	address,
	reviews,
	phone,
	scrollToReviews,
	isGoogleReviewEnabled,
	googleReviews,
	facilityUrl
}) => {
	const hasGoogleReviews =
		isGoogleReviewEnabled && googleReviews?.user_ratings_total > 0;
	const hasVerifiedReviews = reviews?.number > 0;

	const handleScrollToReviews = () => {
		scrollToReviews();
		if (typeof window !== 'undefined' && window.history?.replaceState) {
			const targetBaseUrl = facilityUrl || window.location.pathname;
			window.history.replaceState({}, '', `${targetBaseUrl}#reviews`);
		}
	};

	return (
		<div className="facility-page-header">
			<H1
				mediumSize="large"
				className="facility-name"
			>
				{name}
			</H1>
			<div className="contact-info">
				<span className="facility-address">{address}</span>
				<div className="contact-details">
					{!!phone && (
						<>
							<div className="gray-dot-one" />
							<ShowNumber
								color="blue"
								underline
								phone={phone}
								showNumberOnly
							/>
						</>
					)}
					{hasVerifiedReviews && (
						<>
							<div className="gray-dot-two" />
							<StarReviewV2
								rating={reviews.average}
								reviewCount={reviews.number}
								scrollToReviews={handleScrollToReviews}
							/>
						</>
					)}
					{hasGoogleReviews && (
						<>
							<div className="gray-dot-two" />
							<StarReviewV2
								rating={googleReviews.rating}
								reviewCount={googleReviews.user_ratings_total}
								scrollToReviews={handleScrollToReviews}
								reviewType="google"
								formatCompact
							/>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

FacilityPageHeader.propTypes = {
	name: PropTypes.string,
	address: PropTypes.string,
	reviews: PropTypes.object,
	phone: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	scrollToReviews: PropTypes.func,
	isGoogleReviewEnabled: PropTypes.bool,
	googleReviews: PropTypes.shape({
		rating: PropTypes.number,
		user_ratings_total: PropTypes.number,
		reviews: PropTypes.arrayOf(PropTypes.object),
		placeId: PropTypes.string
	}),
	facilityUrl: PropTypes.string
};

FacilityPageHeader.defaultProps = {
	name: "",
	address: "",
	reviews: {
		average: 0,
		number: 0
	},
	phone: "",
	scrollToReviews: () =>
		document
			.getElementById("reviews")
			?.scrollIntoView({ behavior: "smooth" }),
	isGoogleReviewEnabled: false,
	googleReviews: null
};

export default FacilityPageHeader;
